import { ui } from '@platform/index'

let count = 0

export function loadingRule(): boolean {
  return true
}

export function loadingReqInterceptor<T extends NetRequest>(config: T): NetRequest {
  if (config.useLoading) {
    console.log("ddd---loadingReqInterceptor=========>")
    count += 1;
    (ui.loading() as any).show()
  }
  return config
}

export function loadingResInterceptor<T extends NetRequest>(config: T): NetRequest {
  if (config.useLoading) {
    count -= 1
    if (count === 0)
      (ui.loading() as any).hide()
  }
  return config
}
